import { render, staticRenderFns } from "./TableCreativesV2.vue?vue&type=template&id=1621bf22&scoped=true&"
import script from "./TableCreativesV2.vue?vue&type=script&lang=js&"
export * from "./TableCreativesV2.vue?vue&type=script&lang=js&"
import style0 from "./TableCreativesV2.vue?vue&type=style&index=0&id=1621bf22&prod&lang=scss&"
import style1 from "./TableCreativesV2.vue?vue&type=style&index=1&id=1621bf22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621bf22",
  null
  
)

export default component.exports